import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICoreMemberDTO } from '@app/core/model';
import { SharedMemberService } from '@app/shared/services/shared-member.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class MemberDmePosService extends SharedMemberService {
  constructor(http: HttpClient, shellService: ShellService) {
    super(http, shellService, ProductNames.DMEPOS);
  }

  mapMemberDTO(memberDto: object): ICoreMemberDTO {
    return {
      memberId: memberDto['memberId'],
      benefitPlanID: memberDto['benefitPlanID'], // Observed that this is irrelevant to DMEPOS and only used for HH, but can keep this populated.
      benefitPlanName: memberDto['benefitPlanName'],
      firstName: memberDto['firstName'],
      isEligible: memberDto['isEligible'],
      lastName: memberDto['lastName'],
      lineOfBusiness: memberDto['lineOfBusiness'],
      streamData: {},
      subscriberNumber: memberDto['subscriberNumber'],      
      gender: memberDto['gender'],
      dateOfBirth: memberDto['dateOfBirth'],
      lineOfBusinessId: memberDto['lineOfBusinessId'],
    };
  }
}
